import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import EditIcon from '@mui/icons-material/EditOutlined'
import React from 'react'

import { Menu, MenuItem } from '../../../Menu'

type Props = {
  anchorElement: HTMLElement | null
  dismiss: () => void
  handleDelete: () => void
  handleEdit: () => void
}

export const MenuDialog = React.memo(function MenuDialog(props: Props) {
  const { anchorElement, handleDelete, handleEdit, dismiss } = props

  const isOpen = Boolean(anchorElement)

  return (
    <Menu data-test-id="row-actions-menu-container" anchorEl={anchorElement} open={isOpen} onClose={dismiss}>
      <MenuItem data-test-id="row-actions-edit-button" onClick={handleEdit}>
        <EditIcon color="primary" />
        Edit
      </MenuItem>
      <MenuItem data-test-id="row-actions-delete-button" onClick={handleDelete}>
        <DeleteIcon color="primary" />
        Delete
      </MenuItem>
    </Menu>
  )
})
